import React from "react";
import { SafeAreaView, StyleSheet, Text, View } from "react-native";
import { Colors } from "@/constants/Colors";
import { FontFamilies } from "@/constants/Typography";
import { ActionButton } from "@/components/ActionButton";
import { router } from "expo-router";

const CancelSuccessScreen = () => {
  const handleDone = () => {
    router.dismissAll();
    router.navigate("/(tabs)/account");
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.emoji}>😢</Text>

        <Text style={styles.title}>Subscription canceled</Text>

        <Text style={styles.description}>
          You&apos;ll continue to have access until the end of your current
          billing period. We truly appreciate you trying Sparrow and trusting
          us with your refund search.
        </Text>

        <Text style={styles.description}>
          If you decide to come back, your account and past activity will still
          be here.
        </Text>
      </View>

      <View style={styles.bottomSection}>
        <ActionButton
          title="Done"
          type="primary"
          onPress={handleDone}
          style={styles.doneButton}
        />
      </View>
    </SafeAreaView>
  );
};

export default CancelSuccessScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.background,
  },
  content: {
    flex: 1,
    paddingHorizontal: 24,
    justifyContent: "center",
    alignItems: "center",
  },
  emoji: {
    fontSize: 64,
    marginBottom: 24,
  },
  title: {
    fontSize: 28,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: "#161D14",
    textAlign: "center",
    marginBottom: 24,
  },
  description: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "rgba(22, 29, 20, 0.7)",
    textAlign: "center",
    lineHeight: 22,
    marginBottom: 16,
  },
  bottomSection: {
    paddingHorizontal: 16,
    paddingBottom: 34,
    paddingTop: 12,
    backgroundColor: Colors.background,
  },
  doneButton: {
    width: "100%",
  },
});
